import React, { useEffect, useState } from 'react'
import AccordionTwo from '../Accordion/AccordionTwo'
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import Input from '../Form Elements/Input';

function MiniFilter({ utilities, onCLick }) {

    const [values, setValues] = useState({ min_price: 0, max_price: 0 });

    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const selectedColor = searchParams.getAll('color');
    const selectedSize = searchParams.getAll('size');
    const selectedMaterial = searchParams.getAll('material');
    const selectedTypes = searchParams.getAll('type');


    // Handle Price filter
    useEffect(() => {
        setValues({ ...values, max_price: utilities?.maxPriceProduct?.base_price })
    },
        // eslint-disable-next-line
        [utilities?.maxPriceProduct]
    )



    const priceFilter = () => {
        if (!values.max_price) {
            return
        }
        searchParams.set("min_price", values.min_price)
        searchParams.set("max_price", values.max_price)
        setSearchParams(searchParams)
    }


    const handleColor = (color) => {

        const updatedParams = new URLSearchParams(searchParams);

        if (selectedColor.includes(color)) {
            const newColors = selectedColor.filter(c => c !== color);
            updatedParams.delete("color");
            newColors.forEach((c) => updatedParams.append('color', c));
        } else {
            updatedParams.append('color', color);
        }


        return `${location.pathname}?${updatedParams.toString()}`;
    }

    const handleMaterial = (material) => {
        const updatedParams = new URLSearchParams(searchParams);

        if (selectedMaterial.includes(material)) {
            const newColors = selectedMaterial.filter(c => c !== material);
            updatedParams.delete("material");
            newColors.forEach((c) => updatedParams.append('material', c));
        } else {
            updatedParams.append('material', material);
        }

        return `${location.pathname}?${updatedParams.toString()}`;
    }

    const handleSize = (size) => {
        const updatedParams = new URLSearchParams(searchParams);

        if (selectedSize.includes(size)) {
            const newColors = selectedSize.filter(c => c !== size);
            updatedParams.delete("size");
            newColors.forEach((c) => updatedParams.append('size', c));
        } else {
            updatedParams.append('size', size);
        }

        return `${location.pathname}?${updatedParams.toString()}`;
    }

    const handleType = (type) => {
        const updatedParams = new URLSearchParams(searchParams);

        if (selectedTypes.includes(type)) {
            const newColors = selectedTypes.filter(c => c !== type);
            updatedParams.delete("type");
            newColors.forEach((c) => updatedParams.append('type', c));
        } else {
            updatedParams.append('type', type);
        }

        return `${location.pathname}?${updatedParams.toString()}`;
    }


    return (
        <div className='px-5'>
            {/* Category */}
            <AccordionTwo title="Category" open>
                {utilities && utilities?.categories && utilities?.categories?.length > 0 && (
                    <ul className="w-full mt-2 flex flex-col gap-3">
                        {utilities?.categories?.map((category, i) => (
                            <Link key={i} to={`/product-category/${category?.name?.toLowerCase()}`} className='text-gray-500'>{category?.name}</Link>
                        ))}
                    </ul>
                )}
            </AccordionTwo>

            {/* Price */}
            <AccordionTwo title="Price" open>
                <div className="w-full">
                    <div className='py-5 flex gap-2 items-center'>
                        <div className='space-y-1'>
                            <p className='font-medium'>From:</p>
                            <Input no_rounded style={{ padding: "10px 8px" }} value={values.min_price}
                                type='number'
                                onChange={(e) => {
                                    setValues({ ...values, min_price: e.target.value })
                                }}
                            />
                        </div>
                        <div className='space-y-1'>
                            <p className='font-medium'>To:</p>
                            <Input no_rounded style={{ padding: "10px 8px" }}
                                value={values.max_price}
                                type='number'
                                onChange={(e) => {
                                    setValues({ ...values, max_price: e.target.value })
                                }}
                            />
                        </div>
                    </div>

                    {/* Filter btn */}
                    <button
                        className='text-sm bg-black p-2 px-3 rounded-lg text-white'
                        onClick={priceFilter}
                    >
                        Apply Filter
                    </button>
                </div>
            </AccordionTwo>

            {/* Colors */}
            {utilities?.variants?.colors?.length > 0 && (
                <AccordionTwo title="Colors" open>
                    <div className="flex flex-wrap items-center gap-4 mt-3">
                        {utilities?.variants?.colors?.map((color, i) => (
                            <div key={i}>
                                <Link
                                    style={{ backgroundColor: color }}
                                    to={handleColor(color?.toLowerCase()?.toLowerCase())}
                                    className={`w-7 h-7 border rounded-full block
                                                          ${selectedColor?.includes(color) ? 'ring-1 ring-offset-2 ring-black' :
                                            'ring-transparent ring-offset-0'}`}
                                />
                            </div>
                        ))}
                    </div>
                </AccordionTwo>
            )}

            {/* Sizes */}
            {utilities?.variants?.sizes?.length > 0 && (
                <AccordionTwo title="Sizes" open>
                    <div className="flex flex-wrap items-center gap-2 mt-3">
                        {utilities?.variants?.sizes?.map((size, i) => (
                            <Link
                                to={handleSize(size?.toLowerCase())}
                                key={i}
                                className={`px-2 flex items-center justify-center h-10 border ${selectedSize.includes(size?.toLowerCase()) ? 'bg-black text-white' :
                                    'bg-white text-black'}`}
                            >
                                {size}
                            </Link>
                        ))}
                    </div>
                </AccordionTwo>
            )}


            {/* Materials */}
            {utilities?.variants?.materials?.length > 0 && (
                <AccordionTwo title="Materials" open>
                    <ul className="w-full mt-3 flex flex-col gap-3">
                        {utilities?.variants?.materials?.map((material, i) => (
                            <li key={i}>
                                <Link to={handleMaterial(material?.toLowerCase())}>
                                    <div className='text-gray-500 flex items-center gap-1.5'>
                                        <input type="checkbox" name="" id=""
                                            onChange={() => { }}
                                            checked={selectedMaterial.includes(material?.toLowerCase())}
                                        />
                                        {material}
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </AccordionTwo>
            )}


            {/* Types */}
            {utilities?.variants?.types?.length > 0 && (
                <AccordionTwo title="Types" open>
                    <ul className="w-full mt-3 flex flex-col gap-3">
                        {utilities?.variants?.types?.map((type, i) => (
                            <li key={i}>
                                <Link to={handleType(type?.toLowerCase())}>
                                    <div className='text-gray-500 flex items-center gap-1.5'>
                                        <input type="checkbox" name="" id=""
                                            onChange={() => { }}
                                            checked={selectedTypes.includes(type?.toLowerCase())}
                                        />
                                        {type}
                                    </div>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </AccordionTwo>
            )}

        </div>
    )
}

export default MiniFilter